import { Button } from "../ui/button";
import { MapPin, LogOut, RefreshCw, Bell, BellOff } from "lucide-react";

export function TopBar({
  notificationsEnabled,
  notificationPermission,
  onToggleNotifications,
  onRefresh,
  refreshing,
  onLogout
}) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3 bg-white/90 backdrop-blur-md rounded-full px-4 py-2 shadow-lg">
        <div className="w-8 h-8 rounded-full bg-slate-900 flex items-center justify-center">
          <MapPin className="w-4 h-4 text-white" />
        </div>
        <span className="font-bold text-slate-900 transform rotate-2 italic inline-block">LAND-SLIDE</span>
      </div>
      <div className="flex gap-2">
        <Button
          data-testid="notifications-toggle"
          size="icon"
          variant="secondary"
          className={`rounded-full backdrop-blur-md shadow-lg ${
            notificationsEnabled && notificationPermission === 'granted'
              ? 'bg-white/90 hover:bg-white' 
              : 'bg-slate-200/90 hover:bg-slate-300'
          }`}
          onClick={onToggleNotifications}
          title={
            notificationPermission === 'denied' 
              ? 'Notifications blocked - enable in browser settings'
              : notificationsEnabled 
              ? 'Notifications on' 
              : 'Notifications off'
          }
        >
          {notificationsEnabled && notificationPermission === 'granted' ? (
            <Bell className="w-4 h-4 text-blue-500" />
          ) : (
            <BellOff className="w-4 h-4 text-slate-400" />
          )}
        </Button>
        <Button
          data-testid="refresh-btn"
          size="icon"
          variant="secondary"
          className="rounded-full bg-white/90 backdrop-blur-md shadow-lg hover:bg-white"
          onClick={onRefresh}
          disabled={refreshing}
        >
          <RefreshCw className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`} />
        </Button>
        <Button
          data-testid="logout-btn"
          size="icon"
          variant="secondary"
          className="rounded-full bg-white/90 backdrop-blur-md shadow-lg hover:bg-white"
          onClick={onLogout}
        >
          <LogOut className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
